import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngs-no-tab',
  templateUrl: './no-tab.component.html',
  styleUrls: ['./no-tab.component.scss']
})
export class NoTabComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
